<template>
  <div>
    <!-- 网站弹窗 -->

    <div class="msgBox__modal__2kbbd" data-analytics="button"  v-if="$store.state.appInfo.index_modal == 1 && tanshow" style="display: block">
      <div class="msgBox__modal_HomeAreat_model__2obMO msgBox__modal_CuorsterAreat_model__wwzuA">
        <div class="msgBox__notice_header__kkFdX">
          <span class="msgBox__text__2ODn2" title="">{{$t('index.Welcome')}}{{ $store.state.appInfo.title }}</span
          ><span class="msgBox__close_icon__3J9a5" @click="changtanshow"></span>
        </div>
        <div class="msgBox__notice_content__3Tozy msgBox__notice_content_height__Z3O1m">
          <div class="msgBox__flex__-7cOr common__scroll_bar__28TB7" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
    <div id="redPacket" v-if="bannerList.length > 0 && $store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i class="grab" @click="$parent.goNav('/userredpacket')"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />

      <!-- hongbaocolse.png -->
    </div>
    <!-- <el-carousel trigger="click" style="padding-top:120px">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img :src="item.src" alt="" style="width: 100%;height:100%;" />
      </el-carousel-item>
    </el-carousel> -->
    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#1989fa"  style="padding-top:120px;min-height:400px">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index"><img :src="item.src" alt="" style="width: 100%" /></van-swipe-item>
    </van-swipe> -->
    <!--在页面msite_nav导航部分使用swiper-->
    <div class="swiper-container swiper-no-swiping" style="padding-top: 120px; min-height: 400px; font-size: 0; position: relative; overflow: hidden">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index"><img :src="item.src" alt="" style="width: 100%" /></div>
      </div>
      <!-- swiper轮播图圆点 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
<div class="swiper-button-next" slot="button-next"></div> -->
    </div>

    <div class="txtMarquee-left">
      <div class="block">
        <div class="iconfont icon-tongzhi2"></div>
        <p>{{$t('index.Latest')}}</p>
        <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
          <marquee scrollamount="8" scrolldelay="100" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
            <pre style="color: #fff; font-size: 9.8pt"> <span style="padding-right:100px" v-for="(item, index) in homenoticelis" :key="index"> {{item}}</span></pre>
          </marquee>
        </div>
      </div>
    </div>
    <div class="main" style="background: #0f0f0f">
      <div class="content main clearfix">
        <div class="wow intp fadeInUp index_layer1" data-wow-delay="0" style="visibility: visible">
          <ul>
            <li @click="$parent.goNav('/vip')">
              <div class="bg"></div>

              <div class="nr">
                <div class="icon">
                  <img src="/static/image/pic1.png" alt="icon" />
                </div>
                <div class="text">
                  <h2>{{$t('index.VIP')}}</h2>
                </div>
              </div>
              <div class="pic"></div>
            </li>
            <li @click="$parent.goNav('/recharge')">
              <div class="bg"></div>
              <div class="nr">
                <div class="icon">
                  <img src="/static/image/pic2.png" alt="icon" />
                </div>
                <div class="text">
                  <h2>{{$t('index.Quick')}}</h2>
                </div>
              </div>
              <div class="pic"></div>
            </li>
            <li @click="$parent.goNav('/activity')">
              <a href="javascript:;">
                <div class="bg"></div>
                <div class="nr">
                  <div class="icon">
                    <img src="/static/image/pic3.png" alt="icon" />
                  </div>
                  <div class="text">
                    <h2>{{$t('index.Discount')}}</h2>
                  </div>
                </div>
                <div class="pic"></div>
              </a>
            </li>
            <li @click="$parent.goNav('/app')">
              <a href="javascript:;">
                <div class="bg"></div>
                <div class="nr">
                  <div class="icon">
                    <img src="/static/image/pic4.png" alt="icon" />
                  </div>
                  <div class="text">
                    <h2>APP</h2>
                  </div>
                </div>

                <div class="pic"></div>
              </a>
            </li>
          </ul>
        </div>
        <div class="wow intp fadeInUp title">
          <h2>{{$t('index.Deposit')}}</h2>
          <p></p>
        </div>
        <div class="block1">
          <div class="blockBox block-ag fl" id="aglive" @click="$parent.openGamePage('ag', '1', '')">
            <div class="block-content">
              <img src="/static/image/aglogo.png" />
              <p>{{$t('index.Comprehensive')}}</p>
              <p>{{$t('index.beauty')}}</p>
              <p>{{$t('index.Games')}}</p>
            </div>
          </div>
          <div class="blockBox block-agqj fl" id="agqjlive" @click="$parent.openGamePage('ag', '1', '')">
            <div class="block-content">
              <img src="/static/image/agqjlogo.png" />
              <p>{{$t('index.Exclusive')}}</p>
              <p>{{$t('index.Experience')}}</p>
            </div>
          </div>

          <div class="blockBox block-bbin fl" id="bbinlive" @click="$parent.openGamePage('bbin', 'bbviode', '')">
            <div class="block-content">
              <img src="/static/image/bbinlogo.png" />
              <p>{{$t('index.players')}}</p>
              <p>{{$t('index.baccarat')}}</p>
            </div>
          </div>
          <div class="blockBox block-n2 fl" id="mglive" @click="$parent.openGamePage('qg', '1', '')">
            <div class="block-content">
              <img src="/static/image/oglogo.png" />
              <p>{{$t('index.have')}}</p>
              <p>{{$t('index.beautiful')}}</p>
              <p>{{$t('index.play')}}</p>
            </div>
          </div>
        </div>
        <div class="block2">
          <div class="blockBox block-chess fl" id="chessGame" @click="$parent.goNav('/joker')">
            <div class="block-content">
              <img src="/static/image/pokerlogo.png" />
              <p>{{$t('index.most')}}</p>
              <p>{{$t('index.Classic')}}</p>
              <p>{{$t('index.Preferred')}}</p>
            </div>
          </div>

          <div class="blockBox block-slot fl" id="slotGame" @click="$parent.goNav('/concise')">
            <div class="block-content">
              <img src="/static/image/slotlogo.png" />
              <p>{{$t('index.extreme')}}</p>
              <p>{{$t('index.surprise')}}</p>
              <p>{{$t('index.Gamess')}}</p>
            </div>
          </div>

          <div class="blockBox block-fishing fl" id="fishingGame" @click="$parent.openGamePage('bg', 'egame', '')">
            <div class="block-content">
              <img src="/static/image/fishinglogo.png" />

              <p>{{$t('index.visual')}}</p>
              <p>{{$t('index.levels')}}</p>
              <p>{{$t('index.rich')}}</p>
            </div>
          </div>

          <div class="blockBox block-lottery fl" id="lotteryGame" @click="$parent.goNav('/lottery')">
            <div class="block-content">
              <img src="/static/image/lottery.png" />
              <p>{{$t('index.high')}}</p>
              <p>{{$t('index.Diversified')}}</p>
            </div>
          </div>

          <div class="blockBox block-saba fl" id="sabaGame" @click="$parent.openGamePage('sbtest', '2', '')">
            <div class="block-content">
              <img src="/static/image/sbalogo.png" />
              <p>{{$t('index.richest')}}</p>
              <p>{{$t('index.fast')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wow intp fadeInUp title">
        <h2>{{$t('index.top')}}</h2>
        <p>Top entertainment platforms in the world</p>
      </div>
      <div class="index_layer3">
        <div class="wow intp fadeInLeft layer3_box" data-wow-delay="0">
          <div class="icon">
            <img src="/static/image/gamebg5.png" alt="bg" class="bg" />
            <img src="/static/image/game5.png" alt="bg" class="pic" />
          </div>
          <div class="text">
            <div class="text_box">
              <div class="text_Top">
                <p>{{$t('index.complete')}}</p>
                <a class="playBtn" @click="$parent.goNav('/joker')">PLAY</a>
              </div>
              <div class="text_Bottom">
                <ul>
                  <li>
                    <a @click="$parent.openGamePage('kx', '1', '')"
                      ><img src="/static/image/lg_kyqp.png" alt="icon" />
                      <div class="bt__2w">{{$t('index.Kaiyuan')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('xsj', '1', '')"
                      ><img src="/static/image/lg_nwg.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.New')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('fg', '2', '')"
                      ><img src="/static/image/lg_fgqp.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.FG')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('vg', '2', '')"
                      ><img src="/static/image/lg_vg.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.VG')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.goNav('/joker')"
                      ><img src="/static/image/a15.png" alt="nav" />
                      <div class="bt__2w_vt">{{$t('index.More')}}</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="wow intp fadeInRight layer3_box">
          <div class="icon">
            <img src="/static/image/gamebg4.png" alt="bg" class="bg" />
            <img src="/static/image/game41.png" alt="bg" class="pic" />
          </div>
          <div class="text">
            <div class="text_box">
              <div class="text_Top">
                <p>{{$t('index.chess')}}</p>
                <a class="playBtn" @click="$parent.goNav('/concise')">PLAY</a>
              </div>
              <div class="text_Bottom">
                <ul>
                  <li>
                    <a @click="$parent.openGamePage('hc', 'hc', '')"
                      ><img src="/static/image/syhc.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.Dynasty')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('habaner', 'habaner', '')"
                      ><img src="/static/image/syhb.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.HB')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('pg', 'pg', '')"
                      ><img src="/static/image/lg_pgdz.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.PG')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.goNav('/concise?type=pp')"
                      ><img src="/static/image/sypp.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.PP')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.openGamePage('jdb', 'jdb', '')"
                      ><img src="/static/image/lg_jdb_dz_lhj.png" alt="icon" />
                      <div class="bt__2w_vt">{{$t('index.Indiana')}}</div>
                    </a>
                  </li>
                  <li>
                    <a @click="$parent.goNav('/concise')"
                      ><img src="/static/image/a15.png" alt="nav" />
                      <div class="bt__2w_vt">{{$t('index.More')}}</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index_layer4">
        <ul>
          <li class="wow intp fadeInUp" data-wow-delay="0.6s">
            <a @click="$parent.openGamePage('bg', 'egame', '')">
              <div class="bg bg6"></div>
              <div class="pic pic6"></div>
            </a>
          </li>
          <li class="wow intp fadeInUp" data-wow-delay="0.2s">
            <a @click="$parent.goNav('/sport')">
              <div class="bg bg2"></div>
              <div class="pic pic2"></div>
            </a>
          </li>
          <li class="wow intp fadeInUp" data-wow-delay="0.1s">
            <a @click="$parent.goNav('/lottery')">
              <div class="bg bg1"></div>
              <div class="pic pic1"></div>
            </a>
          </li>
        </ul>
      </div>
      <div class="wow intp fadeInUp title" data-wow-delay="0.1s" style="visibility: visible; animation-delay: 0.1s">
        <h2>{{$t('index.Quality')}}</h2>
        <p>Quality service experience</p>
      </div>
      <div class="index_layer7">
        <ul>
          <li class="wow intp fadeInUp" data-wow-delay="0.1s" style="visibility: visible; animation-delay: 0.1s">
            <img src="/static/image/index_118.png" alt="bg" />
          </li>
          <li class="wow intp fadeInUp" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s">
            <img src="/static/image/index_120.png" alt="bg" />
          </li>
          <li class="wow intp fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s">
            <img src="/static/image/index_122.png" alt="bg" />
          </li>
          <li class="wow intp fadeInUp" data-wow-delay="0.4s" style="visibility: visible; animation-delay: 0.4s" @click="$parent.openKefu">
            <img src="/static/image/index_124.png" alt="bg" />
          </li>
        </ul>
      </div>

      <div class="section section4">
        <img src="/static/image/bg2.jpg" class="bg" />
        <div class="content">
          <div class="row last view view-slideup on">
            <ul class="btmUl clearfix">
              <li class="li03">
                <span class="img"></span>
                <p>{{$t('index.Authorized')}}<span>MACAU AUTHORIZATION</span></p>
              </li>
              <li class="li04">
                <span class="img"></span>
                <p>{{$t('index.Government')}}<span>GRAND USBOA AUTHORIZATION</span></p>
              </li>
              <li class="li02">
                <span class="img"></span>
                <p>{{$t('index.Isle')}}<span>ISLE OF MAN AUTHORIZATION</span></p>
              </li>
              <li class="li01">
                <span class="img"></span>
                <p>{{$t('index.Republic')}}<span>FCLRC AUTHORIZATION</span></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return { homenoticelis: [], bannerList: [], hongbashow: true, tanshow: true };
  },
  created() {
    let that = this;
    that.homenotice(); //获取公告
    that.getBanList(); //获取轮播
  },
  methods: {
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
            that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
    new Swiper('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 2500, // 多长时间进行一次自动切换
        disableOnInteraction: false, // 用户点击一次后是否取消自动切换 默认true
      },
      speed: 300, // 切换速度

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }, //这样写小圆点就有了
      // 如果需要前进后退按钮
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      // 如果需要滚动条
    });

  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/main_81ba8019.85ebbbbe.css';

.txtMarquee-left {
  position: relative;
}
a {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue